<template>
  <div>
    <div v-if="this.$session.get('TokenNetPa')">
     
      
      <div class="border-bottom border-warning pb-2 mb-2">
        <b style="font-size: 15px !important" class="text-dark">انتخاب درگاه پرداخت</b>
      </div>
      <!-- <div class="alert bg-dark-Custom text-center w-100 mt-2">
                <b class="text-warning" style="font-size:15px !important;">انتخاب درگاه ، </b>
                <span class="text-light">پس از اطمینان حاصل کردن از اطلاعات وارد شده ، یکی از درگاه های زیر رانتخاب و بر روی دکمه واریز کلیک کنید</span>
            </div> -->
      <div>
        
        <span class="" v-for="dargah in ListDargah" :key="dargah.id">
          <img v-if="GetDay(dargah)" width="70" @click="ClickLogoDargah(dargah)" :src="dargah.fizicalImageUrl" alt="..." class="rounded Pointer" :class="Dargah == dargah.id ? 'SelectedImageIcon' : ''" />
        </span>

        <img
          v-if="$session.get('AccessMenu').filter((x) => x.id == 64)[0].isMenu && $route.name == 'Deposit' && ShowCustomDeposit"
          width="70"
          @click="Dargah = 100"
          src="/Template/NewMenu/img/NetPaImage/DepositOnAccount.png"
          alt="..."
          class="rounded Pointer mr-2"
          :class="Dargah == 100 ? 'SelectedImageIcon' : ''"
        />
      </div>

      <div class="mt-3" v-for="dargah in ListDargah" :key="dargah.id">
        <span v-if="GetDay(dargah) && dargah.id == Dargah" class="text-dark">{{ dargah.persianName }}</span>
      </div>
      <span v-if="Dargah == 100 && $session.get('AccessMenu').filter((x) => x.id == 64)[0].isMenu && ShowCustomDeposit" class="text-dark">واریز از طریق حساب های موجود در {{ $session.get('IsTaavoniEtebar')==true?'تعاونی اعتبار':'صندوق' }}</span>

      <div class="mt-3">
        {{ Dargah_G }}
        <slot name="ContentButtonPayment"> </slot>
        
       <div class="mt-4 alert alert-warning" v-if="$cookies.get('MablaghKarmozdRial')>0">
        <span class=" text-dark d-inline">مبلغ</span>
        <span class="font-weight-bold text-danger d-inline"> {{ $Comma3ragham($cookies.get('MablaghKarmozdRial')) }} تومان </span>
        <span class=" text-dark d-inline">بابت خدمات غیرحضوری الکترونیک به جمع مبلغ شما اضافه خواهد شد</span>
       </div>
      </div>
    </div>
    <div v-else>
      <!-- <loading v-if="loadingRender"></loading> -->

      <div class="border-bottom border-warning pb-2 mb-2">
        <b style="font-size: 15px !important" class="text-dark">انتخاب درگاه پرداخت  </b>
      </div>
      <!-- <div class="alert bg-dark-Custom text-center w-100 mt-2">
                <b class="text-warning" style="font-size:15px !important;">انتخاب درگاه ، </b>
                <span class="text-light">پس از اطمینان حاصل کردن از اطلاعات وارد شده ، یکی از درگاه های زیر رانتخاب و بر روی دکمه واریز کلیک کنید</span>
            </div> -->
      <div>
        <span class="" v-for="dargah in ListDargah" :key="dargah.id">
          <img v-if="GetDay(dargah)" width="70" @click="ClickLogoDargah(dargah)" :src="dargah.fizicalImageUrl" alt="..." class="rounded Pointer" :class="Dargah == dargah.id ? 'SelectedImageIcon' : ''" />
        </span>
        <span v-show="loading" class="spinner-border  text-danger" role="status" aria-hidden="true" style="width: 3rem; height: 3rem;"></span>
        <!-- <img width="70" @click="Dargah = 100" src="/Template/NewMenu/img/NetPaImage/DepositOnAccount.png" alt="..." class="rounded Pointer mr-2" :class="Dargah == 100 ? 'SelectedImageIcon' : ''" /> -->
      </div>

      <div class="mt-3">
        {{ Dargah_G }}
        <slot name="ContentButtonPayment"> </slot>
        <div class="mt-4 alert alert-warning" v-if="$cookies.get('MablaghKarmozdRial')>0">
        <span class=" text-dark d-inline">مبلغ</span>
        <span class="font-weight-bold text-danger d-inline"> {{ $Comma3ragham($cookies.get('MablaghKarmozdRial')) }} تومان </span>
        <span class=" text-dark d-inline">بابت خدمات غیرحضوری الکترونیک به جمع مبلغ شما اضافه خواهد شد</span>
       </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {

  data() {
    return {
      Dargah: 0,
      ListDargah: [],
      FixVarizGhest: false,
      FixVarizGhestHasJarime: false,
      loading:true
    }
  },
 
  mounted() {
    this.$GetAppsettingsAsync().then(() => {
      this.GetListDargah()
       
    })
    
  },
  computed: {
    Dargah_G() {
      this.$emit('GatewayCode', this.Dargah)
      this.$emit('FixVarizGhest', this.FixVarizGhest)
      this.$emit('FixVarizGhestHasJarime', this.FixVarizGhestHasJarime)
      return ''
    },
  },
  methods: {
    GetListDargah() {
      this.$Gateway().then((data) => {
        if (data.status == 'Ok') {
          data.data.forEach((element) => {
            if ((element.gatewayCode != null || element.gatewayCode != '') && element.isDefault == true) {
              this.Dargah = element.id
              this.FixVarizGhest = element.isFixVarizGhest
              this.FixVarizGhestHasJarime = element.isFixVarizGhestHasJarime
              this.loading=false;
            }
          })

            this.ListDargah = data.data
          

        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'warning', 2000)
        }
      })
      //
      //             var DataAxiosRow={ArryfildValue:{}}
      // DataAxiosRow.Action="GetGateway"
      //    DataAxiosRow.Method= "GET"
      //                 this.$PostData(DataAxiosRow).then((data)=>{
      //                     if (data.status=="Ok") {
      //                         data.data.forEach(element => {
      //                             if(((element.gatewayCode!=null||element.gatewayCode!="") && element.isDefault==true)) {
      //                                 this.Dargah=element.id
      //                                 this.FixVarizGhest=element.isFixVarizGhest
      //                             }
      //                         });
      //                         this.ListDargah=data.data
      //                     }
      //                     else
      //                     {
      //                         this.$mySweetDefaultTost("عدم وجود اطلاعات",data.msg, 'warning', 2000);
      //                     }
      //                 })
    },
    ClickLogoDargah(item) {
      this.Dargah = item.id
      this.FixVarizGhest = item.isFixVarizGhest
      this.FixVarizGhestHasJarime = item.isFixVarizGhestHasJarime
    },
    GetDay(dargah) {
      var NowDay = this.$GetJalaliDate().split('/')[2]

      if (dargah.gatewayCode != null) {
        if (NowDay >= dargah.activeDay.split('-')[0] && NowDay <= dargah.activeDay.split('-')[1]) {
          return true
        }
      }
    },
  },
  props: ['ShowCustomDeposit'],
  created() {},
}
</script>
<style scoped>
.SelectedImageIcon {
  border: 2px dashed #ff9800 !important;
}
.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}
</style>
